module.exports = __webpack_public_path__ + "img/time_line_diamond.7e74265c.svg";